import React from 'react';
import { withTranslation } from 'react-i18next';
// import Loading from '../../../Helpers/Loading';
import Backend from '../../../Layouts/Backend';
import { Button, Input, Loading } from '../../../UI/Common';
import DeleteRecord from '../../../UI/DeleteRecord';
import LoadingButton from '../../../UI/LoadingButton';

function ICSDPage({ t, validationResult, commitResult, ...props }) {
  const [file, setFile] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [commitButtonState, updateCommitBtnState] = React.useState(1); //1: commit, 2: re-validate
  function onUploadFile(e) {
    setFile(null);
    const _file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      function () {
        setFile(_file);
        updateCommitBtnState(1);
        props.validateFile(_file);
      },
      false,
    );
    if (_file) {
      reader.readAsDataURL(_file);
    }
  }

  function displayMessage(msg) {
    if (msg.length === 1) {
      return msg;
    } else if (msg.length > 1) {
      return msg.join('\n');
    }
  }
  function isCommitBtnDisabled() {
    if (
      validationResult &&
      validationResult.filter((result) => result.isValidated).length >= 1
    ) {
      return false;
    }
    return true;
  }
  function getCommitButtonLabel() {
    let text = 'Commit';
    switch (commitButtonState) {
      case 1:
        text = 'Commit';
        break;
      case 3:
        text = 'Error';
        break;
      default:
        text = 'Re-Validate';
        break;
    }
    return t(text);
  }
  return (
    <Backend>
      <div className="content-inner">
        <DeleteRecord
          title={t('Commit')}
          body={t(
            `Are you sure you would like to ${
              commitButtonState === 1 ? 'execute' : 're-validate'
            } the calibrations?`,
          )}
          isOpen={openModal}
          onCancel={() => setOpenModal(false)}
          onConfirm={() => {
            setOpenModal(false);
            if (commitButtonState === 1) {
              props.commitFile(file);
              updateCommitBtnState(2);
            } else if (commitButtonState === 2) {
              props.validateFile(file);
              updateCommitBtnState(1);
            }
          }}
        />
        <p>
          {t('Please use this')}{' '}
          <a className="footer-link" onClick={props.downloadTemplate}>
            {t('template')}
          </a>
        </p>
        <div className="position-relative">
          <Button
            classes="p-0 d-flex w-100 justify-content-center align-items-center"
            style={{ lineHeight: 1 }}
          >
            {t('Select Calibration Data')}
          </Button>
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onClick={(event) => {
              event.target.value = '';
            }}
            onChange={onUploadFile}
            className="position-absolute w-100 h-100"
            style={{ top: 0, opacity: 0 }}
          />
        </div>
        <span>{file ? file.name : null}</span>
        {props.loading ? <Loading /> : null}
        {validationResult ? (
          <div>
            <div className="react-bootstrap-table">
              <table className="table table-hover table-bordered table-sm">
                <thead className="table-header">
                  <tr>
                    <td style={{ textAlign: 'center', width: '15%' }}>
                      {t('Row Number')}
                    </td>
                    <td style={{ textAlign: 'center' }}>{t('Old Serial')}</td>
                    <td style={{ textAlign: 'center' }}>{t('New Serial')}</td>
                    <td style={{ textAlign: 'center' }}>
                      {t('Calibration Date')}
                    </td>
                    <td style={{ textAlign: 'center', width: '15%' }}>
                      {t('Validation Status')}
                    </td>
                    {/* <td>Messages</td> */}
                    {commitResult ? (
                      <td style={{ textAlign: 'center', width: '15%' }}>
                        {t('Commit Status')}
                      </td>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {validationResult.map((res, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: 'center' }}>{res.rowNumber}</td>
                      <td style={{ textAlign: 'center' }}>{res.oldSerial}</td>
                      <td style={{ textAlign: 'center' }}>{res.newSerial}</td>
                      <td style={{ textAlign: 'center' }}>
                        {res.calibratedDate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {res.isValidated ? (
                          <i
                            className="md-icon"
                            style={{
                              fontSize: 24,
                              width: 24,
                              height: 24,
                              color: '#28a745',
                            }}
                            title="Valid"
                          >
                            check_circle
                          </i>
                        ) : (
                          <i
                            className="md-icon"
                            style={{
                              fontSize: 24,
                              width: 24,
                              height: 24,
                              color: '#FF8080',
                            }}
                            title={displayMessage(res.messages)}
                          >
                            cancel
                          </i>
                        )}
                      </td>
                      {/* <td style={{ whiteSpace: 'pre-wrap' }}>
                        {displayMessage(res.messages)}
                      </td> */}
                      {commitResult ? (
                        <td style={{ textAlign: 'center' }}>
                          {commitResult.commitResults.filter(
                            (row) => row.rowNumber === res.rowNumber,
                          )[0].commitStatus ? (
                            <i
                              className="md-icon"
                              style={{
                                fontSize: 24,
                                width: 24,
                                height: 24,
                                color: '#0000FF',
                              }}
                              title="Committed"
                            >
                              check_circle
                            </i>
                          ) : (
                            <i
                              className="md-icon"
                              style={{
                                fontSize: 24,
                                width: 24,
                                height: 24,
                                color: 'grey',
                              }}
                              title={
                                commitResult.commitResults.filter(
                                  (row) => row.rowNumber === res.rowNumber,
                                )[0].messages
                              }
                            >
                              cancel
                            </i>
                          )}
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="react-bootstrap-table">
              <table className="table table-hover table-bordered table-sm mb-0">
                <thead className="table-header">
                  <tr>
                    <td>{t('Total Spreadsheet rows')}</td>
                    <td>{t('Total Valid rows')}</td>
                    <td>{t('Total Invalid Rows')}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{validationResult.length}</td>
                    <td>
                      {
                        validationResult.filter((result) => result.isValidated)
                          .length
                      }
                    </td>
                    <td>
                      {
                        validationResult.filter((result) => !result.isValidated)
                          .length
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : null}
        <LoadingButton
          classes="button button-primary w-100 mt-20"
          disabled={isCommitBtnDisabled()}
          loading={props.isCommitting}
          // onClick={() => props.commitFile(file)}
          onClick={() => setOpenModal(true)}
        >
          {t(getCommitButtonLabel())}
        </LoadingButton>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(ICSDPage);
